import { render, staticRenderFns } from "./ExternalChangesProtect.vue?vue&type=template&id=dc81d6dc&scoped=true&"
import script from "./ExternalChangesProtect.vue?vue&type=script&lang=js&"
export * from "./ExternalChangesProtect.vue?vue&type=script&lang=js&"
import style0 from "./ExternalChangesProtect.vue?vue&type=style&index=0&id=dc81d6dc&lang=scss&scoped=true&"
import style1 from "./ExternalChangesProtect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81d6dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCheckbox,VCol,VContainer,VIcon,VRow,VTooltip})
